import { reactive } from 'vue'

/**
 * Fenêtre « Premiers pas » (mise en route de la boutique active) : ouverte depuis
 * l'en-tête ou le panneau d'aide. L'avancement est rechargé à chaque ouverture ; l'en-tête
 * l'utilise aussi pour son badge (étapes restantes).
 */
export const onboardingState = reactive({
    open: false,
    progress: null,
})

export async function loadOnboardingProgress() {
    try {
        const { data } = await window.axios.get('onboarding/progress', { silent: true })
        onboardingState.progress = data
    } catch (e) {
        onboardingState.progress = null
    }
    return onboardingState.progress
}

export function openOnboarding() {
    onboardingState.open = true
    loadOnboardingProgress()
}

export function closeOnboarding() {
    onboardingState.open = false
}
